var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tabs',{attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":"产品类型"}},[_c('productType',{ref:"productType"})],1),_c('el-tab-pane',{attrs:{"label":"产品系列"}},[_c('productSet',{ref:"productSet"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }